import { GoogleAiVoiceDraftV1, GoogleAiVoiceSegment } from '../types';

const normalizeSegment = (segment: GoogleAiVoiceSegment): GoogleAiVoiceSegment => ({
  id: segment.id,
  speaker: segment.speaker,
  text: segment.text.replace(/\r\n/g, '\n').trim(),
});

export const canonicalizeGoogleDraft = (draft: GoogleAiVoiceDraftV1): string => {
  const normalized: GoogleAiVoiceDraftV1 = {
    version: 1,
    provider: 'google',
    model: draft.model,
    languageCode: draft.languageCode.trim(),
    multiSpeaker: Boolean(draft.multiSpeaker),
    promptSpeakerA: (draft.promptSpeakerA ?? '').trim(),
    promptSpeakerB: (draft.promptSpeakerB ?? '').trim(),
    speakers: {
      speakerA: {
        voiceId: draft.speakers.speakerA.voiceId.trim(),
        displayName: draft.speakers.speakerA.displayName.trim(),
      },
      speakerB: {
        voiceId: draft.speakers.speakerB.voiceId.trim(),
        displayName: draft.speakers.speakerB.displayName.trim(),
      },
    },
    segments: draft.segments.map(normalizeSegment),
    prompt: (draft.prompt ?? '').trim(),
  };

  return JSON.stringify(normalized);
};
